/**
 *
 */
export function someGetter(/* state */) {}
